/** Canonical roof storey id — matches the backend `ROOF` value. UI labels stay German ("Dach"). */
export const roofStoreyKey = 'ROOF'
